import { render, staticRenderFns } from "./Recall.vue?vue&type=template&id=7e349a5e&scoped=true&"
import script from "./Recall.vue?vue&type=script&lang=js&"
export * from "./Recall.vue?vue&type=script&lang=js&"
import style0 from "./Recall.vue?vue&type=style&index=0&id=7e349a5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e349a5e",
  null
  
)

export default component.exports